import type { CampaignRegistrationVo, Page, CampaignRegistrationForm, Company } from "@zhihaoscm/entity";
import httpRequest from "./index";

/**
 * 分页查询活动报名信息-pc端
 */
export const campaignRegistrationPagingAll = (params: {
    page: number;
    size: number;
    keyword?: string;
}) => {
    return httpRequest.get<Page<CampaignRegistrationVo>>(`/campaign-registration/paging-custom`, {params});
};

/**
 * 查询报名信息详情
 */
export const campaignRegistrationDetail = (code: string) => {
    return httpRequest.get<CampaignRegistrationVo>(`/campaign-registration/findByCode?code=${code}`); 
};

/**
 * 新增报名信息
 */
export const campaignRegistrationCreate = (params: CampaignRegistrationForm) => {
    return httpRequest.post(`/campaign-registration/create`, params);
};


/**
 * 修改报名信息
 */
export const campaignRegistrationUpdate = (params: CampaignRegistrationForm) => {
    return httpRequest.post(`/campaign-registration/update`, params);
};

/**
 * 报名支付-上传凭证
 */
export const campaignRegistrationPay = (params: {
    // 报名单id
    id: number;
    // 支付凭证
    fileIds: number[];
}) => {
    return httpRequest.post(`/campaign-registration/pay`, params);
};

/**
 * 报名修改支付凭证
 */
export const campaignRegistrationUpdatePayFile = (params: {
    // 报名单id
    id: number;
    // 支付凭证
    fileIds: number[];
}) => {
    return httpRequest.post(`/campaign-registration/update-pay-file`, params);
};

/**
 * 企业抬头详细信息下拉列表
 */
export const campaignRegistrationCompanyHeadSelector = ( params: {page:number,size:number,name: string} ) => {
    return httpRequest.get<{ data: Page<Company> }>(`/campaign-registration/company-head-selector`, {params});
};